export default {
  'component.tagSelect.expand': 'Expandir',
  'component.tagSelect.collapse': 'Plegar',
  'component.tagSelect.all': 'Tot',
};
